import {
  TextField,
  NumberInput,
  DateTimeInput,
  SelectField,
  TextInput,
  useRecordContext,
  Link,
  SelectArrayInput,
} from "react-admin";
import EnhancedEncryptionIcon from "@mui/icons-material/EnhancedEncryption";
import { MyList } from "../ra-lb-tools/components/myList";
import { MyReferenceField } from "../ra-lb-tools/components/myReference";
import { useParams } from "react-router-dom";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import {
  MyTabbedShowLayout,
  Tab,
} from "../ra-lb-tools/components/myTabbedShowLayout";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import { LockerUsageEventList } from "./billing/lockerUsageEvent";
import { expandTokenizedTemplate } from "../ra-lb-tools/utils/tools";
import { JsonField } from "../ra-lb-tools/components/jsonField";
import { ClientField } from "./clients";
import get from "lodash/get";
import { UserField, UserInput } from "./users";
import { MyDateField } from "../ra-lb-tools/components/myDateField";
import { TowerInput } from "./tower/towers";

export const openLockerTokenIcon = EnhancedEncryptionIcon;

const intentChoices = [
  { id: 1, name: "Dropoff" },
  { id: 2, name: "Pickup" },
  { id: 3, name: "Release" },
  { id: 4, name: "Emergency" },
];

const openLockerTokenFilters = () => [
  <NumberInput label="Locker Id" source="lockerId" alwaysOn key={1} />,
  <SelectArrayInput
    label="Intent"
    source="intent"
    alwaysOn
    key={2}
    choices={intentChoices}
  />,
  <DateTimeInput label="Expires after" source="expires_at_gt" key={3} />,
  <TowerInput
    label="Tower"
    source="locker__tower_id"
    alwaysOn
    key="locker__tower_id"
  />,
  <UserInput source="userId" label="User" allowEmpty alwaysOn key="userId" />,
  <TextInput source="clientInfo" alwaysOn key="clientInfo" />,
];

export const OpenLockerTokenClientInfo = ({ record }) => {
  const clientInfoTemplates =
    get(record, "clientSettings.requestInfoParser") || [];

  record = record || useRecordContext();

  for (let index = 0; index < clientInfoTemplates.length; index++) {
    const clientInfoTemplate = clientInfoTemplates[index];
    const parsed = expandTokenizedTemplate(
      clientInfoTemplate,
      record.clientInfo
    );
    if (parsed) {
      return (
        <Link to={parsed} target="_blank">
          <TextField record={record} source="clientInfo" />
        </Link>
      );
    }
  }

  return <TextField record={record} source="clientInfo" />;
};

export const OpenLockerTokenList = (props) => {
  const resource = "open-locker-tokens";

  return (
    <MyList
      {...props}
      filters={openLockerTokenFilters()}
      resource={resource}
      dataGridProps={{
        omit: ["clientSettings", "spClient"],
      }}
    >
      <TextField source="id" />
      <MyReferenceField
        source="lockerId"
        reference="lockers"
        link="show"
        label="Locker"
      />
      <UserField source="userId" sortable={false} />
      <SelectField choices={intentChoices} source="intent" sortable={false} />
      <MyDateField source="expiresAt" showTime />
      <OpenLockerTokenClientInfo source="clientInfo" sortable={false} />
      <TextField source="currentToken" sortable={false} />
      <TextField source="nextToken" sortable={false} />
      <MyReferenceField
        source="lockerOpenRequestId"
        reference="locker-open-requests"
        primaryField="id"
      />
      <ClientField
        source="clientSettings.clientExternalId"
        label="Client"
        sortable={false}
      />
      <JsonField source="spClient" />
      <JsonField source="clientSettings" />
    </MyList>
  );
};

export const OpenLockerTokenShow = () => {
  const id = parseInt(useParams()["id"]);

  return (
    <MyShow>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <MyReferenceField
                source="lockerId"
                reference="lockers"
                link="show"
                label="Locker"
              />
              <UserField source="userId" />
              <SelectField
                choices={intentChoices}
                source="intent"
                sortable={false}
              />
              <MyDateField source="expiresAt" showTime />
            </LabeledColumn>
            <LabeledColumn>
              <OpenLockerTokenClientInfo source="clientInfo" sortable={false} />
              <TextField source="currentToken" sortable={false} />
              <TextField source="nextToken" sortable={false} />
              <MyReferenceField
                source="lockerOpenRequestId"
                reference="locker-open-requests"
                primaryField="id"
              />
              <ClientField
                source="clientSettings.clientExternalId"
                label="Client"
                sortable={false}
              />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
        <Tab
          label="Locker Usage Events"
          path="locker-usage-events"
          can={{ action: "list", resource: "locker-usage-events" }}
        >
          <LockerUsageEventList filter={{ openLockerTokenId: id }} />
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};
